<template>
    <!--  서브페이지  -->

    <!--콘텐츠 영역-->
    <div id="sub_contents" class="sub_contents location">
        <ul class="location_wrap">
            <li>
                <div class="company_adress">
                <div class="company_adress_tit">
                    <img :src="require('./../../assets/img/sub/01/0105_00.png')" />
                    <h3>송원문화재단</h3>
                </div>
                <!-- 25.02 구글맵 -> 네이버 지도로 변경 -->
                <NaverMap :mapKey="1" :latitude="35.1482772" :longitude="129.0654374" width="578px" height="300px" />
                <div class="company_adress_txt">
                    <span>A.</span>
                    <P>부산광역시 남구 전포대로 133, 3710호 (문현동, IFC부산오피스텔)</P><br>
                    <span>T.</span>
                    <P>(051)611-5459</P>
                </div>
                </div>
            </li>
            <li>
                <div class="company_adress">
                <div class="company_adress_tit">
                    <img :src="require('./../../assets/img/sub/01/0105_00.png')" />
                    <h3>송원아트센터</h3>
                </div>
                <NaverMap :mapKey="2" :latitude="37.5792684" :longitude="126.9833844" width="578px" height="300px" />
                <div class="company_adress_txt">
                    <span>A.</span>
                    <P>서울특별시 종로구 윤보선길 75(화동)</P><br>
                    <span>T.</span>
                    <P>(02)735-9277</P>
                </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import NaverMap from "./NaverMap.vue";

export default {
    components: {
        NaverMap
    },
    data: () => ({
        message: "Location.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>
 


// WEBPACK FOOTER //
// src/components/sub03/Location.vue